export const RECTANGLE = {
    id: 12,
    y1: 100,
    x1: 150,
    top: 100,
    left: 150,
    itemTop: 100,
    itemLeft: 150,
    itemId: 12,
    title: "R",
    x2: 0,
    y2: 0,
    dataType: "Rectangle",
    itemName: "Rectangle",
    description: "Rectangle",
    itemFill: "Transparent",
    itemStroke: "Black",
    itemStrokeThickness: 2,
    height: 150,
    width: 250,
    itemFont: 0,
    itemWeight: "",
    itemLineType: "Solid",
    zOrder: 1
}


export const DEEP_TEXT = {
    id: 14,
    y1: 165,
    x1: 200,
    top: 165,
    left: 200,
    itemTop: 165,
    itemLeft: 200,
    itemId: 14,
    title: "Deep",
    x2: 0,
    y2: 0,
    dataType: "Text",
    itemName: "TextDeep",
    description: "DEEP",
    itemFill: "Transparent",
    itemStroke: "Transparent",
    itemStrokeThickness: 0,
    height: 20,
    width: 50,
    itemFont: 16,
    itemWeight: "Normal",
    itemLineType: "",
    zOrder: 0
}


export const SHALLOW_TEXT = {
    id: 15,
    y1: 165,
    x1: 280,
    top: 165,
    left: 280,
    itemTop: 165,
    itemLeft: 280,
    itemId: 15,
    title: "Shallow",
    x2: 0,
    y2: 0,
    dataType: "Text",
    itemName: "TextShallow",
    description: "SHALLOW",
    itemFill: "Transparent",
    itemStroke: "Transparent",
    itemStrokeThickness: 0,
    height: 20,
    width: 60,
    itemFont: 16,
    itemWeight: "Normal",
    itemLineType: "",
    zOrder: 0
}
